import { render, staticRenderFns } from "./NewsListPage.vue?vue&type=template&id=15e62cff&scoped=true"
import script from "./NewsListPage.vue?vue&type=script&lang=js"
export * from "./NewsListPage.vue?vue&type=script&lang=js"
import style0 from "./NewsListPage.vue?vue&type=style&index=0&id=15e62cff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e62cff",
  null
  
)

export default component.exports